export default function (state) {
    let form = state;
    let data = {};

    switch (form.dateType) {
        case 1:
            if (form.dates[0]) data.CreateDateFrom = {Serialized: form.dates[0]};
            if (form.dates[1]) data.CreateDateTo = {Serialized: form.dates[1]};
            break;
        case 2:
            if (form.dates[0]) data.PaymentDateFrom = {Serialized: form.dates[0]};
            if (form.dates[1]) data.PaymentDateTo = {Serialized: form.dates[1]};
            break;
        case 3:
            if (form.dates[0]) data.ChangeDateFrom = {Serialized: form.dates[0]};
            if (form.dates[1]) data.ChangeDateTo = {Serialized: form.dates[1]};
            break;
    }
    if (form.CurrencyId.length) data.CurrencyId = form.CurrencyId;
    if (form.DepartmentList.length) data.DepartmentList = form.DepartmentList;
    if (form.ManagerList.length) data.ManagerList = form.ManagerList;
    if (form.CashList.length) data.CashList = form.CashList;
    if (form.PaymentAccountList.length) data.PaymentAccountList = form.PaymentAccountList;


    if (form.CategoryId || form.CategoryId === 0) data.CategoryId = form.CategoryId;
    if (form.Direction) data.Direction = form.Direction;
    if (form.ContragentType) data.ContragentType = form.ContragentType;
    if (form.ContragentID) {
        data.ContragentID = form.ContragentID;
        data.ContragentSearchTypeId = form.ContragentSearchTypeId;
    }

    if (form.AgreementCode) data.AgreementCode = encodeURIComponent(form.AgreementCode);
    if (form.RequestNumber) data.RequestNumber = form.RequestNumber;
    if (form.PaymentReason) data.PaymentReason = form.PaymentReason;
    if (form.DocumentNumber) data.DocumentNumber = form.DocumentNumber;
    if (form.AccountNumber) data.AccountNumber = form.AccountNumber;
    if (form.PaymentOperationID) data.PaymentOperationID = form.PaymentOperationID;
    if (form.PaymentTypeId || form.PaymentTypeId === 0) data.PaymentTypeId = form.PaymentTypeId;
    if (form.StatementName) data.StatementName = form.StatementName;
    if (form.MinAmount) data.MinAmount = form.MinAmount;
    if (form.MaxAmount) data.MaxAmount = form.MaxAmount;
    if (form.PaySystemTransactionId) data.PaySystemTransactionId = form.PaySystemTransactionId;
    if (form.PaymentMethodId) data.PaymentMethodId = form.PaymentMethodId;
    if (form.DateStatement) data.DateStatement = {Serialized:form.DateStatement};
    if (form.KindOfPayId) data.KindOfPayId = form.KindOfPayId;
    if (form.NoDetailedOnly) data.NoDetailedOnly = form.NoDetailedOnly;
    if (form.RateArticleId) data.RateArticleId = form.RateArticleId;
    if (form.AddValues) data.AddValues = form.AddValues;
    if (form.addCashCheck) {
        data.OnlineCashId = form.OnlineCashId;
        data.BillProvideTypeId = form.BillProvideTypeId;
    }
    return data;
}